import { useMutation } from "react-query";
import { addAlarmType } from "../../../../../actions/Utilities/AlarmType";
import { toast } from "components/toastNotification";
import { IAlarmType } from "../types";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  addStateAlarmType,
  alarmTypeReFetching,
} from "../atoms/atoms";

const useAddAlarmType = () => {
  const setIsAddState = useSetRecoilState(addStateAlarmType);
  const [isReFetching, setIsReFetching] = useRecoilState(
    alarmTypeReFetching
  );

  const { mutate } = useMutation(
    (NewData: IAlarmType) => addAlarmType(NewData),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire("Adding Alarm Type failed", res.Message, "error");
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Alarm Type Added Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Alarm Type Added Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Adding Alarm Type failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Adding Alarm Type failed",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Adding Alarm Type failed", res, "error");
          }
        }

        // Redirect to View
        setIsAddState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },

      onError: (error: any) => {
        toast.fire("Add Alarm Type failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
};
export default useAddAlarmType;
